<div class="modal-overlay" *ngIf="show && automationFeatureEnabled" (click)="close.emit()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="modal-title">Automation Settings</div>
      <button class="modal-close" (click)="close.emit()" [disabled]="autoTaskSaving">✕</button>
    </div>
    <div class="modal-body">
      <div class="error-msg" *ngIf="automationError">{{ automationError }}</div>

      <div class="form-row">
        <label>
          <input type="checkbox" [checked]="autoEnableBattleSync" (change)="setAutoEnableBattleSync.emit($any($event.target).checked)"> Sync battle log to DB
        </label>
      </div>
      <div class="form-row">
        <label>
          <input type="checkbox" [checked]="autoEnableDonationExtend" (change)="setAutoEnableDonationExtend.emit($any($event.target).checked)"> Auto-extend selected donations
        </label>
      </div>

      <div class="form-row" *ngIf="donatedCrew?.length">
        <div class="section-title">Active donated crew</div>
        <div class="select-list">
          <label class="select-list-item" *ngFor="let crew of donatedCrew">
            <div class="select-list-item-left">
              <input type="checkbox"
                [checked]="autoDonationSelectedIds.has(crew.characterId)"
                (change)="toggleDonationSelection.emit({ characterId: crew.characterId, selected: $any($event.target).checked })">
              <div class="select-list-item-text">
                <span>{{ crew.customName || characterDesigns.get(crew.designId)?.name || '#' + crew.characterId }}</span>
                <small>{{ crew.level }} Lv</small>
              </div>
            </div>
            <span class="select-list-item-badge">{{ crew.maxDonate ? (crew.maxDonate + 'x') : '' }}</span>
          </label>
        </div>
      </div>

      <div class="form-row">
        <label>Schedule type:</label>
        <select [value]="autoScheduleType" (change)="onAutoScheduleTypeChange($any($event.target).value)">
          <option value="interval">Interval</option>
          <option value="cron">Cron</option>
          <option value="times">Daily times</option>
        </select>
      </div>
      <div class="form-row" *ngIf="autoScheduleType === 'interval'">
        <label>Interval (seconds):</label>
        <input type="number" min="60" [value]="autoIntervalSec" (input)="onIntervalSecChange($any($event.target).value)">
      </div>
      <div class="form-row" *ngIf="autoScheduleType === 'cron'">
        <label>Cron expression (UTC):</label>
        <input type="text" [value]="autoCronExpression" (input)="setAutoCronExpression.emit($any($event.target).value)" placeholder="0 2 * * *" maxlength="100">
      </div>
      <div class="form-row" *ngIf="autoScheduleType === 'times'">
        <label>Daily times (UTC):</label>
        <div class="times-input-group">
          <input type="time" [value]="autoScheduleTimeInput" (input)="onScheduleTimeInputChange($any($event.target).value)" />
          <button type="button" class="btn btn-primary btn-sm" (click)="addScheduleTime.emit()">Add</button>
        </div>
        <ul class="times-list">
          <li *ngFor="let time of autoScheduleTimes">
            <span>{{ time }}</span>
            <button type="button" class="btn btn-ghost btn-sm" (click)="removeScheduleTime.emit(time)">✕</button>
          </li>
        </ul>
        <small>Multiple times can be selected; the task will run when the current UTC time matches any configured minute.</small>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-ghost" (click)="close.emit()" [disabled]="autoTaskSaving">Cancel</button>
      <button class="btn btn-primary" (click)="save.emit()" [disabled]="autoTaskSaving">{{ autoTaskSaving ? 'Saving…' : 'Save Settings' }}</button>
    </div>
  </div>
</div>
